import {
  discountRuleConditionsSchema,
  discountRuleTypeConfigSchema,
  discountValueSchema,
  MAX_DISCOUNT_MESSAGE_LENGTH,
} from "@redotech/redo-model/discount-rules/discount-rule";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createDiscountRule = {
  name: "createDiscountRule" as const,
  input: z.object({
    discountMessage: z.string().min(1).max(MAX_DISCOUNT_MESSAGE_LENGTH),
    discount: discountValueSchema,
    conditions: discountRuleConditionsSchema,
    typeConfig: discountRuleTypeConfigSchema,
  }),
  output: z.object({ ruleId: zExt.objectId() }),
};
